import { render, staticRenderFns } from "./scrapingSetting.vue?vue&type=template&id=3953fdbf&"
import script from "./scrapingSetting.vue?vue&type=script&lang=js&"
export * from "./scrapingSetting.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports